import React, { useRef } from "react";

import useError from "@hooks/useError";
import useStores from "@hooks/useStores";
import useStyles from "@hooks/useStyles";
import useConstants from "@hooks/useConstants";

import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

import ButtonLoading from "@components/Global/Custom/Button";
import TextField from "@components/Global/Custom/TextField";

import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CloseIcon from "@material-ui/icons/Close";
import Link from "@material-ui/core/Link";

import Logo from "@components/Global/Custom/Logo/Logo";

const { BRAND_NAME } = process.env;

const SignupWithEmail = ({}) => {
	const classes = useStyles("ProSignupFunnel");

	const { signupWithEmailStore: store, proSignupFunnelModalStore } =
		useStores();
	const [ErrorTemplate, onError] = useError();

	const emailRef = useRef();
	const passwordRef = useRef();
	const phoneRef = useRef();
	const textNotificationRef = useRef();

	// const { width, height } = useConstants("ProSignupFunnelViewModel");
	const width = 120;
	const height = "inherit";

	const signupOnClickHandler = async (e) => {
		e.preventDefault();
		await store
			.signup({
				email: emailRef.current.value,
				phone: phoneRef.current.value,
				password: passwordRef.current.value,
				enableTextNotifications: textNotificationRef.current.checked,
			})
			.catch(onError);
	};

	return (
		<React.Fragment>
			<DialogTitle id="scroll-dialog-title" disableTypography>
				<IconButton
					aria-label="close"
					className={classes.closeModal}
					onClick={() => proSignupFunnelModalStore.onClose()}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<Box p={{ xs: 0, sm: "0px 16px 16px" }}>
					<Box mb={5} mt={5}>
						<Box mb={4}>
							<Logo width={width} height={height} />
						</Box>

						<div className={classes.modalHead}>Create your free account</div>
						<p>Sign up to start hearing from new customers.</p>
					</Box>

					<form onSubmit={signupOnClickHandler}>
						<Grid container spacing={4}>
							<Grid item xs={12} sm={6}>
								<TextField
									groupId={"signup-form"}
									type={"email"}
									inputRef={emailRef}
									variant="outlined"
									fullWidth
									label="Email address"
									id="username"
									name="username"
								/>
							</Grid>

							<Grid item xs={12} sm={6}>
								<TextField
									groupId={"signup-form"}
									type={"tel"}
									inputRef={phoneRef}
									variant="outlined"
									fullWidth
									label="Mobile phone number"
									id="tel"
									name="tel"
								/>
							</Grid>

							{/* Message frequency varies and data rates may apply. Reply HELP for help or STOP to cancel */}

							<Grid item xs={12}>
								{/* <Box
									component={"div"}
									fontSize={16}
									lineHeight={"22px"}
									fontWeight={"600"}
									mb={4}
								>
									Create a password
								</Box> */}

								<TextField
									groupId={"signup-form"}
									type={"password"}
									variant={"outlined"}
									label="Password"
									InputProps={{
										labelWidth: 80,
									}}
									fullWidth
									inputRef={passwordRef}
									name="password"
									id="password"
								/>
							</Grid>

							<Grid item xs={12}>
								<Box
									display="flex"
									alignItems={"center"}
									justifyContent={"space-between"}
								>
									<FormControl>
										<FormControlLabel
											className={classes.rememberMe}
											control={
												<Checkbox
													inputRef={textNotificationRef}
													defaultChecked={true}
													name="checkedB"
													color="primary"
												/>
											}
											label="Enable text messages"
										/>
										<Box ml={8}>
											<FormHelperText>
												By keeping this box checked and tapping "Sign up", you
												authorize {BRAND_NAME} to send you automated text
												messages. You can opt out anytime.{" "}
												<Link href="/terms-of-service#sms" target={"_blank"}>
													Terms apply
												</Link>
												.
											</FormHelperText>
										</Box>
									</FormControl>
								</Box>
							</Grid>

							<ErrorTemplate />

							<Grid item xs={12}>
								<Box mt={2} mb={5}>
									<Box
										component={"div"}
										mb={5}
										fontSize={12}
										color={"grey.700"}
										lineHeight={1.5}
									>
										By tapping "Sign up", you agree to our{" "}
										<Link href="/terms-of-service" target={"_blank"}>
											terms of service
										</Link>{" "}
										and{" "}
										<Link href="/privacy-policy" target={"_blank"}>
											privacy policy
										</Link>
										.
									</Box>

									<ButtonLoading
										fullWidth
										type={"submit"}
										onClick={signupOnClickHandler}
										className={classes.btn}
										size={"large"}
										variant="contained"
										color="primary"
										disableElevation
										label={"Sign up"}
									/>
								</Box>
							</Grid>
						</Grid>
					</form>
				</Box>
			</DialogContent>
		</React.Fragment>
	);
};

SignupWithEmail.propTypes = {};

export default SignupWithEmail;
